import React, { Component } from 'react';
import './Maintenance.scss';
import { SettingsIconGradiant } from './Icon';

class Maintenance extends Component {
    render() {
        const { start, end } = this.props;

        return (
            <div className='mp-body'>
                <div className="mp-maintenance-container">
                    <div className='mp-icon-div'>
                        <div className="mp-icon">
                            <SettingsIconGradiant />
                        </div>
                    </div>
                    <h1>Scheduled Maintenance</h1>
                    <p className="mp-description">
                        We are currently performing scheduled maintenance to improve our services. Our
                        system will be temporarily unavailable during this time.
                    </p>
                    <div className="mp-maintenance-details">
                        <div className="mp-time-details">
                            <div>🕒 Start Time: {start}</div>
                            <div>🕒 End Time: {end}</div>
                        </div>
                        <div>
                            We are working on:
                            <ul>
                                <li>System upgrades</li>
                                <li>Performance improvements</li>
                                <li>Security enhancements</li>
                            </ul>
                        </div>
                    </div>
                    <p className="mp-contact">
                        If you need immediate assistance, please contact our support team at{' '}
                        <a href="mailto:care@uniqus.com">care@uniqus.com</a>
                    </p>
                </div>
            </div>
        );
    }
}

export default Maintenance;
